<template>
    <!-- <v-layout fill-height> -->
    <v-container>
        <v-layout>
            <v-card outlined color="transparent" class="d-none d-lg-block">
                <v-navigation-drawer hide-overlay permanent clipped>
                    <template v-slot:prepend>
                        <v-list-item two-line>
                            <v-list-item-avatar>
                                
                                <img v-if="user.avatarUrl" width="48" :src="user.avatarUrl" /> 
                                <v-avatar v-else color="#e9531c">
                                    <span class="text-body-1 white--text">{{ shortcutName }}</span>
                                </v-avatar>
                                <!-- <span class="mdi mdi-account-circle mdi-36px"></span> -->
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title>{{ fullName }}</v-list-item-title>
                                <v-list-item-subtitle><small>{{ user.email }}</small></v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </template>

                    <v-divider></v-divider>

                    <v-list dense nav>
                        <v-list-item link v-for="item in items" :key="item.title" :to="item.route"
                            @click.native="item.action && item.action()">
                            <v-list-item-icon>
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <template>
                        </template>
                    </v-list>
                </v-navigation-drawer>
            </v-card>

            <v-container class="align-top justify-center pa-4" style="min-height: 300px;">
                <router-view name="account"></router-view>
            </v-container>

        </v-layout>
    </v-container>
</template>
<script>

export default {
    name: 'Homepage',
    components: {

    },
    mounted() {
        this.getProfileInfo();
    },
    data() {
        return {
            user: {
                firstName: '',
                lastName: '',
                email: '',
                avatarUrl: null
            },

            items: [
                { title: 'account.home.title', icon: 'mdi-home-city', route: '/account/home' },
                { title: 'account.clubcard.title', icon: 'mdi-heart', route: '/account/clubcard' },
                { title: 'account.orders.title', icon: 'mdi-cart', route: '/account/orders' },
                { title: 'account.tickets.title', icon: 'mdi-ticket', route: '/account/tickets' },
                { title: 'account.profile.title', icon: 'mdi-cog', route: '/account/profile' },
                { title: 'account.password.title', icon: 'mdi-account', route: '/account/password' },
                {
                    title: 'account.logout',
                    icon: 'mdi-logout',
                    route: "/",
                    action: () => this.logout()
                }
            ],
        }
    },
    computed: {
        fullName(){            
            return this.user.firstName + ' ' + this.user.lastName;
        },
        shortcutName() {
            return (this.user.firstName ? this.user.firstName.substring(0, 1).toUpperCase() : '') 
                    + (this.user.lastName ? this.user.lastName.substring(0, 1).toUpperCase() : '');
        }
    },
    methods: {
        getProfileInfo() {
            window.axios
            .get(process.env.VUE_APP_ROOT_API + process.env.VUE_APP_API_ROOT + "/users/me")
            .then(response => {
                this.user.firstName =  response.data.firstName;
                this.user.lastName =  response.data.lastName;
                this.user.email =  response.data.email;       
                this.user.avatarUrl = response.data.avatarUrl;      
            })
            .catch(error => {
                console.log(error)
            })            
        },
        logout() {
            this.$store.dispatch("logout");
        }
    }
}
</script>
